import styled, { css } from 'styled-components';
import variables from '../../../styles/variables';

import Link from '../Link/Link';
import { CssClassName } from '../../../utils/generateCssClassName/types';

/* TextLink sizes */
const sizeCss = css`
  &.large {
    font-weight: 400;
    font-size: 18px;
    line-height: 18px;
    letter-spacing: 0.2px;
  }
  &.medium {
    font-weight: 400;
    font-size: 16px;
    line-height: 16px;
    letter-spacing: 0.2px;
  }
  &.small {
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    letter-spacing: 0.2px;
  }
  &.xsmall {
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    letter-spacing: 0.2px;
  }
`;

/* TextLink styles */
const styleCss = css`
  &.red {
    color: ${variables.colorRed};
    transition:
      background-color 0.3s,
      color 0.3s;
    &:hover,
    &:focus {
      color: ${variables.colorRedHover};
    }
  }
  &.black {
    color: ${variables.colorBlack};
    transition:
      background-color 0.3s,
      color 0.3s;
    &:hover,
    &:focus {
      color: ${variables.colorBlackHover};
    }
  }
  &.white {
    color: ${variables.colorWhite};
    transition:
      background-color 0.3s,
      color 0.3s;
    &:hover,
    &:focus {
      color: ${variables.colorWhiteHover};
    }
  }
`;

export const InternalTextLink = styled(Link)<{ showActiveState?: boolean }>`
  ${sizeCss}
  ${styleCss}

  &.${CssClassName.KIOSK} {
    display: none;
  }
  ${({ showActiveState }) => showActiveState && css`
    &.active {
      text-decoration: underline;
    }
  `}
`;

export const ExternalTextLink = styled.a`
  ${sizeCss}
  ${styleCss}

  &.${CssClassName.KIOSK} {
    display: none;
  }
`;

export const FunctionalTextLink = styled.button`
  appearance: none;
  padding: 0;
  border: 0;
  outline: 0;
  text-decoration: underline;
  background-color: transparent;
  cursor: pointer;

  ${sizeCss}
  ${styleCss}

  &.${CssClassName.KIOSK} {
    display: none;
  }
`;
